export interface Role {
    roleId?: number;
    name?: string;
    isDeleted?: boolean;
}

export enum RoleConstants {
    BILD_ADMIN = 'BILD_ADMIN',
    BILD_OPERADOR = 'BILD_OPERADOR', 
    BILD_ENCARGADO = 'BILD_ENCARGADO', 
    BILD_VENTAS = 'BILD_VENTAS',
    CLIENTE_ADMIN = 'CLIENTE_ADMIN',
    CLIENTE_OPERADOR = 'CLIENTE_OPERADOR',
}

export const BILD_ROLES: string[] = [
  RoleConstants.BILD_ADMIN,
  RoleConstants.BILD_OPERADOR,
  RoleConstants.BILD_ENCARGADO,
  RoleConstants.BILD_VENTAS
];

export const CLIENT_ROLES: string[] = [
  RoleConstants.CLIENTE_ADMIN,
  RoleConstants.CLIENTE_OPERADOR
];

export type RoleAction = 'edit' | 'delete' | 'accountSelection';

export type PermissionType = {
    edit: string[];
    delete: string[];
    accountSelection: string[];
  };